<template>
  <v-container fluid>
    <v-layout row>
      <v-expansion-panel focusable>
        <v-expansion-panel-content class="mycustomExpansionPanel">
          <template v-slot:actions>
            <v-icon large color="primary">$vuetify.icons.expand</v-icon>
          </template>
          <template v-slot:header>
            <div>
              <v-icon color="primary">search</v-icon>
              <span class="pl-2 subheading">Custom Search Panel</span>
            </div>
          </template>
          <v-layout row wrap align-center>
            <v-flex>
              <v-card class="px-3">
                <v-layout row wrap align-center class="py-3">
                  <v-flex xs4>
                    <v-text-field
                      v-model="searchParam.reg_no"
                      type="number"
                      class="ma-2"
                      menu-props="auto"
                      label="Regestration Number"
                      prepend-icon="edit"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      v-model="searchParam.col_code"
                      type="number"
                      class="ma-2"
                      menu-props="auto"
                      label="College Code"
                      prepend-icon="edit"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs4>
                    <v-select
                      v-model="searchParam.status"
                      :items="items"
                      item-text="state"
                      item-value="value"
                      label="Select Status"
                      prepend-icon="list"
                      clearable
                      single-line
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center row fill-height align-center>
                      <v-btn color="primary" @click="searchStudent()" large>
                        Search
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>
    <br />
    <br />
    <!-- v-if="getProbableData.length" -->
    <v-card color="white">
      <v-layout row>
        <v-card flat>
          <v-badge left overlap>
            <template v-slot:badge>
              <v-btn
                round
                color="primary"
                fab
                small
                style="margin-top: -1.3em;"
                class="elevation-0"
                >{{ specialFormFillUpList.length }}</v-btn
              >
            </template>
            <v-card-text class="title"
              >Special Form Fill-up Application</v-card-text
            >
          </v-badge>
        </v-card>
        <v-divider class="my-2" vertical></v-divider>
        <v-spacer />
      </v-layout>
    </v-card>
    <!-- :items="getProbableData" -->
    <v-layout row>
      <v-flex>
        <v-card flat>
          <v-data-table
            :headers="Listheaders"
            :items="specialFormFillUpList"
            :search="search"
            class="elevation-1"
            :rows-per-page-items="[
              25,
              50,
              100,
              { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
            ]"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>{{ props.index + 1 }}</td>
              <td class="text-xs">{{ props.item.reg_no }}</td>
              <td class="text-xs">{{ props.item.std_name }}</td>
              <td class="text-xs">{{ props.item.college_name }}</td>
              <td class="text-xs">
                {{ props.item.applied_by }} at {{ props.item.applied_at }}
              </td>
              <td class="text-xs-center">
                <v-btn
                  v-if="props.item.status == 'Pending'"
                  color="red"
                  dark
                  small
                  >{{ props.item.status }}</v-btn
                >
                <v-btn
                  v-if="props.item.status == 'Approved'"
                  color="green"
                  dark
                  small
                  >{{ props.item.status }}</v-btn
                >
              </td>
              <td class="text-xs">
                <span v-if="props.item.status == 'Approved'"
                  >{{ props.item.approved_by }} at
                  {{ props.item.approved_at }}</span
                >
              </td>
              <td class="text-xs-center">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      v-if="props.item.status == 'Pending'"
                      small
                      fab
                      color="indigo"
                      style="color: #fff;"
                      @click="confirmCancelLetter(props.item.id)"
                    >
                      <v-icon dark>task_alt</v-icon>
                    </v-btn>
                  </template>
                  <span>Approve Application</span>
                </v-tooltip>

                <v-btn
                  fab
                  dark
                  small
                  color="red"
                  v-if="props.item.status == 'Approved'"
                  style="margin-left: 20px; border-radius: 100px"
                  @click="cancleStudentApplication(props.item.id)"
                >
                  <v-icon>block</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="confirmDialog" persistent max-width="400px">
      <v-card>
        <v-card-title
          class="headline"
          style="background-color: #5666BE; color: #fff;"
          >Confirm Action</v-card-title
        >
        
        <v-card-text style="text-align: center; font-size: large;">
          Are you sure you want to Approve this letter?
        </v-card-text>

        <v-card-actions style="text-align: center;">
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            style="color: #fff;"
            small
            @click="confirmDialog = false"
          >
            No
          </v-btn>
          <v-btn color="indigo" style="color: #fff;" small @click="approveApp">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import commonGet from "../../../mixin/common_getters_mixin";

export default {
  mixins: [commonGet],
  data() {
    return {
      items: [
        { state: "Pending", value: "pending" },
        { state: "Approved", value: "approved" },
      ],
      appId: "",
      confirmDialog: false,
      selectedLetterId: null,
      getProbableData: [],
      col_code: "",
      pagination: {},
      searchParam: {},
      dialog: false,
      search: "",
      reg_no: "",
      mobile: "",
      form_fill_up_id: null,
      Listheaders: [
        {
          text: "SL.",
          sortable: false,
          align: "left",
          value: "id",
          width: "10",
        },
        { text: "REG. No.", value: "student.reg_no", sortable: false },
        { text: "Student Name", value: "student.name", sortable: false },
        {
          text: "College Code & Name",
          value: "student.mobile",
          sortable: false,
        },
        { text: "Applyed By", value: "", sortable: false },
        { text: "Status", align: "center", value: "status", sortable: true },
        { text: "Approved By", value: "", sortable: false },
        { text: "Actions", align: "center", value: "actions", sortable: false },
      ],
      valid: true,
      today_date: "",
    };
  },
  computed: {
    specialFormFillUpList() {
      return this.$store.getters.getSpetialFFstudenListAdmin;
    },
  },

  created() {
    this.searchStudent();
  },
  methods: {
    searchStudent() {
      this.$store.dispatch("getSpecialFFStudentListAdmin", {
        exam_code: this.getLoggedInExam.code,
        exam_year: this.getLoggedInYear.year,
        reg_no: this.searchParam.reg_no,
        status: this.searchParam.status,
        college_code: this.searchParam.col_code,
      });
    },

    confirmCancelLetter(id) {
      this.confirmDialog = true;
      this.appId = id;
    },

    approveApp() {
      console.log("Tanvir app id", this.appId);
      this.$store
        .dispatch("ApproveSpecialFFApplicationAdmin", this.appId)
        .then(() => {
          this.confirmDialog = false;
          this.searchStudent();
        });
    },

    cancleStudentApplication(id) {
      console.log("Tanvir! cancle this Application", id);
      this.$root
        .$confirm("Are you sure that you want to cancle this Application?")
        .then((confirm) => {
          if (confirm) {
            this.loading = true;
            this.$store
              .dispatch("cancleSpecialFFApplicationAdmin", id)
              .then((data) => {
                console.log("Tanvir! removed", data);
                this.loading = false;
                this.searchStudent();
              });
          } else {
            this.loading = false;
          }
        });
    },
  },
  watch: {},
};
</script>
<style scoped>
/* table.v-table tbody td,
table.v-table tbody th {
  height: 0px;
  white-space: nowrap;
} */
</style>





